class StorageService {

  static getTableCollapseState(tableId) {
    let res = localStorage.getItem(`TABLE_SEARCH_COLLAPSE_${tableId}`);
    return new Promise((resolve) => resolve(res === null ? true : res === 'true'));
  }

  static setTableCollapseState(tableId, val) {
    localStorage.setItem(`TABLE_SEARCH_COLLAPSE_${tableId}`, val);
  }
}

export {
  StorageService
};
